import type { ReactNode } from 'react'
import { Box, keyframes, useMediaQuery } from '@mui/material'

const valueRefresh = keyframes`
  from {
    opacity: 0;
    transform: translateY(6px) scale(0.985);
    filter: blur(2px);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
`

type PortfolioKpiValueMotionProps = {
  transitionKey: string
  children: ReactNode
  minHeight?: number
  justifyContent?: 'flex-start' | 'center' | 'flex-end'
}

const PortfolioKpiValueMotion = ({
  transitionKey,
  children,
  minHeight = 24,
  justifyContent = 'flex-start',
}: PortfolioKpiValueMotionProps) => {
  const reduceMotion = useMediaQuery('(prefers-reduced-motion: reduce)')

  return (
    <Box
      sx={{
        width: '100%',
        minHeight,
        display: 'flex',
        alignItems: 'center',
        justifyContent,
        overflow: 'hidden',
      }}>
      <Box
        key={transitionKey}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          animation: reduceMotion ? 'none' : `${valueRefresh} 220ms cubic-bezier(0.2, 0.8, 0.2, 1)`,
          transformOrigin: 'center left',
          willChange: reduceMotion ? 'auto' : 'transform, opacity, filter',
        }}>
        {children}
      </Box>
    </Box>
  )
}

export default PortfolioKpiValueMotion
